import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const pains = [{
  title: 'Tus piezas se grietan o rompen',
  desc: 'Invertiste tiempo, cemento y pigmentos pero la pieza salió mal. Sin las proporciones exactas y los aditivos correctos, perdés material y dinero en cada intento fallido.'
}, {
  title: 'No sabés cuánto cobrar',
  desc: 'Ponés precios "a ojo", vendés barato para competir y al final del mes descubrís que trabajaste horas para ganar casi nada. La inflación te come el margen sin que te des cuenta.'
}, {
  title: 'No encontrás proveedores serios',
  desc: 'Comprás en la ferretería del barrio a precio de mostrador. No sabés dónde conseguir pigmentos industriales, selladores ni desmoldantes profesionales a precio mayorista.'
}, {
  title: 'Tus fotos no generan ventas',
  desc: 'Publicás en Instagram, recibís "me gusta" pero nadie pregunta el precio. Las piezas son hermosas pero las fotos no hacen justicia. El que no sabe mostrar bien su producto, no vende.'
}, {
  title: 'Los moldes se arruinan rápido',
  desc: 'Comprás moldes importados caros que al tercer uso se deforman o rompen. Sin saber fabricar tus propios moldes, tu costo de producción es imposible de sostener.'
}, {
  title: 'No sabés por dónde empezar a vender',
  desc: 'Tenés las piezas y las ganas, pero el camino para llegar al cliente está tan desordenado que publicás una vez y abandonás. Sin método, solo tenés un hobby caro.'
}];
export function PainPoints() {
  return <section aria-label="Problemas" className="border-y border-white/5 bg-ink-2" data-id="element-107" data-mp="1b4supbov0oei">
      <div className="mx-auto max-w-4xl px-5 pt-[5px]" data-id="element-108" data-mp="1p3sh0cowgr7i">
        <h2 className="pt-[24px] text-center font-display text-[25px] font-black text-white sm:text-4xl" data-id="element-109" data-mp="1k2wb5tkzmuzg">
          ❌ ¿Cuánta plata más vas a perder sin un sistema?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-white/70" data-id="element-110" data-mp="2vil18ttjga4h">
          Sos creativo. Querés vivir de tu arte. Pero después de semanas de intentos, mezclas que se
          grietan, moldes que se rompen y fotos que nadie comenta… empezás a dudar.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-cemento-soft" data-id="element-111" data-mp="225tod2abow8u">
          No es falta de talento. No es falta de ganas. Es falta de un sistema.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-112" data-mp="272k5zu1rzzwd">
          {pains.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="flex gap-3 rounded-xl border border-white/10 bg-ink p-5" data-id="element-113" data-mp="1acko38zqjp14" data-mpi={i}>
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white/10 text-cemento-soft" data-id="element-114" data-mp="qpwlsb9kadt5">
                <XIcon className="h-4 w-4" strokeWidth={3} data-id="element-115" data-mp="vnenphp5vsrn" />
              </span>
              <div data-id="element-116" data-mp="o5gt0jbn2m8h">
                <h3 className="text-sm font-bold text-white" data-id="element-117" data-mp="o3vyuut8l5b5">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-white/60" data-id="element-118" data-mp="j7yhcl68lsws">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 pb-12 text-center" data-id="element-119" data-mp="a70fo9j9txhd">
          <p className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-120" data-mp="a8jtlthgfwfz">
            ¿Y si este fuera el último mes que fabricás sin un método real?
          </p>
          <p className="mt-3 text-lg font-semibold text-gold" data-id="element-121" data-mp="fvxz227nyiu">
            Tu primer lote de piezas de lujo puede ser diferente.
          </p>
        </div>
      </div>
    </section>;
}